export default __webpack_public_path__ + "71e991eafedaeda0c612bf4f5a69bc70.svg";